module.exports = __webpack_public_path__ + "img/logo-1.74b3a4cf.png";